import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';

import DiscoverButton from '../../shared_components/DiscoverButton/DiscoverButton';
import { NavigationState } from '../../util/constants';
import { ClickableDiv } from '../index';

import { IProps } from './NavButtons.types';

import styles from './NavButtons.module.scss';

const NavButtons = (props: IProps) => {
  const {
    tabs,
    rightSideLink,
    sendCurrentTabIndex,
    fullWidthButtons,
    initialActiveTab,
    inlineFilters,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState(initialActiveTab ?? 0);

  const handleButtonClick = (index: number) => {
    const { persistTabState, replaceTabState } = props;
    // Update URL state to persist the selected tab
    if (persistTabState) {
      navigate(
        {
          ...location,
        },
        {
          replace: Boolean(replaceTabState),
          state: {
            ...(location.state || {}),
            [persistTabState]: index,
          },
        },
      );
    }
    sendCurrentTabIndex && sendCurrentTabIndex(index);
    setActive(index);
  };

  useEffect(() => {
    setActive(initialActiveTab ?? 0);
  }, [initialActiveTab]);

  return (
    <>
      <div
        className={classNames(styles.wrapper, {
          [styles.fullWidthButtons]: fullWidthButtons,
          [styles.withFilters]: inlineFilters,
        })}
      >
        <div
          className={classNames(styles.buttonsWrapper, {
            [styles.buttonsFullWidth]: fullWidthButtons,
          })}
        >
          {/* TODO : Refactor this part and remove commented code HW-691 */}
          {/* {!isWatchlist && (
            <div
              className={styles.slidingBackground}
              style={isMobile ? {
                transform: `translateX(${active * 100}%)`,
              } : {
                transform: `translateX(${active * 86}%)`,
                width: active === 0 ? '104px' : '120px',
              }}
            />
          )}
          {isWatchlist && (
            <div
              className={styles.slidingBackground}
              style={isMobile ? {
                transform: `translateX(${active * 100}%)`,
              } : {
                transform: `translateX(${active * 76}%)`,
                width: active === 0 ? '80px' : '100px',
              }}
            />
          )} */}
          {tabs.map((tab, index) => (
            <ClickableDiv
              key={tab.text}
              onClick={() => handleButtonClick(index)}
              className={classNames(styles.button, {
                [styles.activeButton]: index === active,
                [styles.endButton]: index === 1,
                [styles.halfWidth]: fullWidthButtons,
                [styles.alignTextCenter]: fullWidthButtons,
              })}
            >
              {tab.text}
            </ClickableDiv>
          ))}
        </div>
        {inlineFilters && <>{inlineFilters}</>}
        {rightSideLink && (
          <DiscoverButton
            onClick={() => {
              if (rightSideLink.state) {
                navigate(
                  {
                    pathname: rightSideLink.link,
                  },
                  {
                    state: {
                      [NavigationState]: rightSideLink.state,
                    },
                  },
                );
              } else {
                navigate(rightSideLink.link);
              }
            }}
          />
        )}
      </div>
      {tabs[Math.min(active, tabs.length - 1)]?.component}
    </>
  );
};

export default NavButtons;
